
export const formatDate = (dateString: string): string => {
  const date = new Date(dateString);
  const today = new Date();
  const yesterday = new Date(today);
  yesterday.setDate(yesterday.getDate() - 1);

  if (date.toDateString() === today.toDateString()) {
    return 'Hari ini';
  } else if (date.toDateString() === yesterday.toDateString()) {
    return 'Kemarin';
  } else {
    return new Intl.DateTimeFormat('id-ID', {
      day: 'numeric',
      month: 'short',
      year: 'numeric',
    }).format(date);
  }
};

export const formatTransactionDateTime = (utcTimestamp: string): string => {
  // Parse UTC timestamp and convert to GMT+7 (WIB)
  const date = new Date(utcTimestamp);

  // Format as DD MMM YYYY, HH:MM in GMT+7 timezone
  const formatter = new Intl.DateTimeFormat('id-ID', {
    day: '2-digit',
    month: 'short',
    year: 'numeric',
    hour: '2-digit',
    minute: '2-digit',
    hour12: false,
    timeZone: 'Asia/Jakarta', // GMT+7 (WIB)
  });

  const formatted = formatter.format(date);

  // Intl.DateTimeFormat for id-ID returns format like "13 Okt 2025 pukul 14.30"
  // We need to clean it to "13 Okt 2025, 14:30"
  return formatted
    .replace(' pukul ', ', ')
    .replace('.', ':');
};

export const formatTransactionDate = (dateString: string): string => {
  // Parse date and format as DD MMM YYYY (no time)
  const date = new Date(dateString);

  const formatter = new Intl.DateTimeFormat('id-ID', {
    day: '2-digit',
    month: 'short',
    year: 'numeric',
    timeZone: 'Asia/Jakarta', // GMT+7 (WIB)
  });

  return formatter.format(date);
};
